import { OpDashboard, OpDashboardControl, OpDashboardData } from "../models/custom"
import { DashboardModel, DescrModel, DashboardRowModel, DashboardColumnModel, DashboardItemModel, MeterModel, FileModel, FieldModel } from "../modules/api/api.models"
import { OpDescr, OpMeter, OpData } from "../models/core"
import { Enums } from "../models/common"
import { OpBaseData } from "../models/common/op-base"

export class BackwardCompatibilityHelper {

    public static opDashboardToDashboardModel(dashboard: OpDashboard): DashboardModel {
        if (dashboard != null) {
            const model: DashboardModel = new DashboardModel()
            model.backgroundColor = dashboard.backgroundColor
            model.configurationSourceId = dashboard.configurationSourceId
            model.configurationSourceLevel = dashboard.configurationSourceLevel
            model.descriptions
            model.files
            model.fitToScreen = dashboard.fitToScreen
            model.id = dashboard.idDashboard
            model.idDashboard = dashboard.idDashboard
            model.keepAspectRatio = dashboard.keepAspectRatio
            model.margin = dashboard.margin
            model.maxHeight = dashboard.maxHeight
            model.maxWidth = dashboard.maxWidth
            model.nameDescriptions = this.OpDescrToDescrModel(dashboard.name)
            model.opState = dashboard.opState
            model.padding = dashboard.padding
            model.useMargin = dashboard.useMargin
            model.usePadding = dashboard.usePadding
            model.width = dashboard.width
            model.idStartupIndicator = dashboard.idStartupIndicator
            model.type = dashboard.type
            model.dataList = dashboard.dataList.toArray().map((data: OpDashboardData) => {
                return <OpDashboardData>{
                    idDataType: data.idDataType,
                    indexNbr: data.indexNbr,
                    value: data.value,
                    opState: data.opState
                }
            })

            return model
        }
        return null
    }

    public static DashboardModelToOpDashboard(model: DashboardModel): OpDashboard {
        if (model != null) {
            const opDashboard: OpDashboard = new OpDashboard()
            opDashboard.fitToScreen = model.fitToScreen
            opDashboard.idDashboard = model.id
            opDashboard.keepAspectRatio = model.keepAspectRatio
            opDashboard.maxHeight = model.maxHeight
            opDashboard.maxWidth = model.maxWidth
            opDashboard.useMargin = model.useMargin
            opDashboard.usePadding = model.usePadding
            opDashboard.width = model.width
            opDashboard.opState = model.opState
            opDashboard.configurationSourceLevel = model.configurationSourceLevel
            opDashboard.configurationSourceId = model.configurationSourceId
            opDashboard.backgroundColor = model.backgroundColor
            opDashboard.name = this.DescrModelToOpDescr(model.nameDescriptions)
            opDashboard.idStartupIndicator = model.idStartupIndicator
            opDashboard.type = model.type
            if (model.dataList != null) {
                opDashboard.dataList.push(...model.dataList)
            }

            opDashboard.controls = []
            if (model.rows != null) {
                model.rows.forEach((row: DashboardRowModel) => {
                    row.columns.forEach((column: DashboardColumnModel) => {
                        column.items.forEach((item: DashboardItemModel) => {
                            const control: OpDashboardControl = new OpDashboardControl()
                            control.class = item.type
                            control.configurationSourceLevel = item.configurationSourceLevel

                            control.opState = item.opState
                            control.type = this.DescrModelToOpDescr(item.descr)

                            opDashboard.controls.push(control)
                        })
                    })
                })
            }
            return opDashboard
        }
        return null
    }

    public static DescrModelToOpDescr(model: DescrModel): OpDescr {
        if (model != null) {
            const descr = new OpDescr()
            descr.description = model.description
            descr.idDescr = model.idDescr
            descr.idLanguage = model.idLanguage
            descr.opState = model.opState
            if (model.allLanguagesDescription && model.allLanguagesDescription.length) {
                descr.allLanguagesDescription = model.allLanguagesDescription.map((descr: DescrModel) => {
                    return this.DescrModelToOpDescr(descr)
                })
            }
            return descr
        }
        return null
    }

    public static OpDescrToDescrModel(model: OpDescr): DescrModel {
        if (model != null) {
            const descr = new DescrModel()
            descr.description = model.description
            descr.idDescr = model.idDescr
            descr.idLanguage = model.idLanguage
            descr.opState = model.opState
            if (model.allLanguagesDescription && model.allLanguagesDescription.length) {
                descr.allLanguagesDescription = model.allLanguagesDescription.map((descr: OpDescr) => {
                    return this.OpDescrToDescrModel(descr)
                })
            }
            return descr
        }
        return null
    }

    public static OpMeterToMeterModel(model: OpMeter): MeterModel {
        const meterModel: MeterModel = new MeterModel()
        meterModel.id = model.idMeter
        meterModel.idMeterType = model.idMeterType
        meterModel.idMeterTypeClass = model.meterType.idMeterTypeClass
        meterModel.referenceId = model.idMeter
        meterModel.detailsFields = model.dataList.toArray().map((opData: OpData) => {
            const fieldModel: FieldModel = new FieldModel()
            fieldModel.idDataType = opData.idDataType
            fieldModel.name = opData.idDataType.toString()
            fieldModel.id = opData.idData
            fieldModel.typeId = opData != null && opData.dataType && opData.dataType.idDataTypeClass != null ? opData.dataType.idDataTypeClass : 0
            fieldModel.value = opData.value
            return fieldModel
        })
        //TODO
        return meterModel
    }
}